import { render, staticRenderFns } from "./BaseListUlmoudle2.vue?vue&type=template&id=d9f3d204&scoped=true&"
import script from "./BaseListUlmoudle2.vue?vue&type=script&lang=js&"
export * from "./BaseListUlmoudle2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f3d204",
  null
  
)

export default component.exports